import { Controller } from "@hotwired/stimulus"

// Asks "nur diesen Termin / diesen und alle folgenden / ganze Serie" before an edit or a
// deletion that touches a recurring appointment goes through.
//
// The dialog intercepts the submit (or the delete click), and the chosen scope is written
// into a hidden field so the server sees an ordinary form post. Without the interception
// the request would already be on its way by the time the user answered.
export default class extends Controller {
  static targets = ["dialog", "option", "scopeField", "title", "optionLabel"]
  static values = { editTitle: String, deleteTitle: String, stopTitle: String }

  connect() {
    this.pendingAction = null
  }

  // data-action="submit->series-scope#interceptSubmit" on the edit form.
  interceptSubmit(event) {
    if (this.resolved) return

    event.preventDefault()
    this.pendingAction = () => {
      this.resolved = true
      event.target.requestSubmit()
    }
    // Unticking "Wiederholen" asks the same three questions about different outcomes.
    const stopping = this.recurrenceTurnedOff()
    this.applyLabels(stopping)
    this.open(stopping ? this.stopTitleValue : this.editTitleValue)
  }

  recurrenceTurnedOff() {
    const toggle = this.element.querySelector("input[name='recurrence[enabled]']")
    return Boolean(toggle) && !toggle.checked
  }

  applyLabels(stopping) {
    this.optionLabelTargets.forEach((label) => {
      const text = stopping ? label.dataset.stopLabel : label.dataset.defaultLabel
      if (text) label.textContent = text
    })
  }

  // data-action="click->series-scope#interceptDelete" on the delete control.
  interceptDelete(event) {
    if (this.resolved) return

    event.preventDefault()
    const trigger = event.currentTarget
    this.pendingAction = () => {
      this.resolved = true
      trigger.click()
    }
    this.applyLabels(false)
    this.open(this.deleteTitleValue)
  }

  open(title) {
    if (!this.hasDialogTarget) return

    if (this.hasTitleTarget && title) this.titleTarget.textContent = title
    this.dialogTarget.showModal()
  }

  cancel() {
    this.pendingAction = null
    if (this.hasDialogTarget) this.dialogTarget.close()
  }

  confirm() {
    const chosen = this.optionTargets.find((option) => option.checked)
    if (this.hasScopeFieldTarget && chosen) this.scopeFieldTarget.value = chosen.value

    // The delete control carries the scope in its URL rather than in a form field.
    if (chosen) this.applyScopeToDeleteLinks(chosen.value)

    if (this.hasDialogTarget) this.dialogTarget.close()
    const action = this.pendingAction
    this.pendingAction = null
    if (action) action()
  }

  applyScopeToDeleteLinks(scope) {
    this.element.querySelectorAll("[data-series-scope-url]").forEach((element) => {
      const url = new URL(element.dataset.seriesScopeUrl, window.location.origin)
      url.searchParams.set("series_scope", scope)
      if (element.tagName === "A") element.href = url.pathname + url.search
      if (element.tagName === "FORM") element.action = url.pathname + url.search
    })
  }
}
